var exports = {
  "ui": "TreeItemLabel__OATr0E",
  "zO": "TreeItemCheckbox__ExWV4J",
  "CG": "TreeItemOverflow__zGW9q6",
};

module.exports = exports;
